<div class="feedback-admin-container">
  <div class="feedback-admin-header">
    <button class="back-button" (click)="onBackClick()" aria-label="Back to chat">
      <img src="assets/icons/collection-arrow.svg" alt="Back" class="back-arrow-icon">
    </button>
    <div class="feedback-admin-heading">
      <h1 class="feedback-admin-title">Feedback</h1>
      <p class="feedback-admin-subtitle">Review user feedback and resolve items once they have been handled.</p>
    </div>
  </div>

  <div class="loading-state" *ngIf="isLoading">
    <div class="loading-spinner"></div>
  </div>

  <div class="error-state" *ngIf="error && !isLoading">
    <div class="error-content">
      <p class="error-message">{{ error }}</p>
      <button class="retry-button" (click)="loadFeedbacks()">Retry</button>
    </div>
  </div>

  <div class="feedback-admin-content" *ngIf="!isLoading && !error">
    <section class="feedback-dropdown">
      <button
        type="button"
        class="dropdown-trigger"
        (click)="toggleSection('new')"
        [attr.aria-expanded]="isNewFeedbacksOpen">
        <div class="dropdown-title-group">
          <span class="dropdown-title">New Feedbacks</span>
          <span class="count-badge">{{ newFeedbacks.length }}</span>
        </div>
        <span class="dropdown-arrow" [class.open]="isNewFeedbacksOpen">&#9662;</span>
      </button>

      <div class="dropdown-panel" *ngIf="isNewFeedbacksOpen">
        <div class="empty-state" *ngIf="newFeedbacks.length === 0">
          No new feedbacks right now.
        </div>

        <div class="feedback-list" *ngIf="newFeedbacks.length > 0">
          <article
            class="feedback-summary-card"
            *ngFor="let item of newFeedbacks; trackBy: trackByFeedback"
            (click)="openFeedbackDetails(item)">
            <div class="feedback-summary-main">
              <div class="feedback-summary-top">
                <div>
                  <div class="feedback-user">{{ item.userName || item.userId }}</div>
                  <div class="feedback-meta">
                    <span>{{ item.chatLabel || 'Untitled Chat' }}</span>
                    <span>{{ getSortDate(item) | date:'medium' }}</span>
                  </div>
                </div>
              </div>

              <p class="feedback-preview">{{ getFeedbackPreview(item) }}</p>
          </div>

            <div class="feedback-summary-actions">
              <span class="tone-chip" [class.negative]="item.feedback.isLiked === false">{{ getFeedbackTone(item) }}</span>
              <button
                type="button"
                class="resolve-btn"
                (click)="resolveFeedback(item); $event.stopPropagation()"
                [disabled]="resolvingKey === getFeedbackKey(item)">
                {{ resolvingKey === getFeedbackKey(item) ? 'Resolving...' : 'Resolve' }}
              </button>
            </div>
          </article>
        </div>
      </div>
    </section>

    <section class="feedback-dropdown">
      <button
        type="button"
        class="dropdown-trigger"
        (click)="toggleSection('resolved')"
        [attr.aria-expanded]="isResolvedFeedbacksOpen">
        <div class="dropdown-title-group">
          <span class="dropdown-title">Resolved Feedbacks</span>
          <span class="count-badge">{{ resolvedFeedbacks.length }}</span>
        </div>
        <span class="dropdown-arrow" [class.open]="isResolvedFeedbacksOpen">&#9662;</span>
      </button>

      <div class="dropdown-panel" *ngIf="isResolvedFeedbacksOpen">
        <div class="empty-state" *ngIf="resolvedFeedbacks.length === 0">
          No resolved feedbacks yet.
        </div>

        <div class="feedback-list" *ngIf="resolvedFeedbacks.length > 0">
          <article
            class="feedback-summary-card resolved"
            *ngFor="let item of resolvedFeedbacks; trackBy: trackByFeedback"
            (click)="openFeedbackDetails(item)">
            <div class="feedback-summary-main">
              <div class="feedback-summary-top">
                <div>
                  <div class="feedback-user">{{ item.userName || item.userId }}</div>
                  <div class="feedback-meta">
                    <span>{{ item.chatLabel || 'Untitled Chat' }}</span>
                    <span>{{ getSortDate(item) | date:'medium' }}</span>
                  </div>
                </div>
              </div>

              <p class="feedback-preview">{{ getFeedbackPreview(item) }}</p>

              <div class="resolved-meta">
                Resolved{{ item.feedback.resolvedByName ? ' by ' + item.feedback.resolvedByName : '' }}
                <span *ngIf="item.feedback.resolvedAt"> on {{ item.feedback.resolvedAt | date:'medium' }}</span>
              </div>

            </div>
            <div class="feedback-summary-actions">
              <span class="tone-chip" [class.negative]="item.feedback.isLiked === false">{{ getFeedbackTone(item) }}</span>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>

  <div
    class="feedback-modal-overlay"
    *ngIf="selectedFeedback"
    (click)="closeFeedbackDetails()">
    <div class="feedback-modal" (click)="$event.stopPropagation()">
      <div class="feedback-modal-header">
        <div *ngIf="viewMode === 'feedback'">
          <h2 class="feedback-modal-title">{{ selectedFeedback.userName || selectedFeedback.userId }}</h2>
          <div class="feedback-meta">
            <span>{{ selectedFeedback.chatLabel || 'Untitled Chat' }}</span>
            <span>{{ getSortDate(selectedFeedback) | date:'medium' }}</span>
          </div>
        </div>

        <div *ngIf="viewMode === 'history'" class="history-header">
          <button type="button" class="back-button" (click)="backToFeedbackDetails()" aria-label="Back to feedback">
            <img src="assets/icons/collection-arrow.svg" alt="Back" class="back-arrow-icon">
          </button>
          <div>
            <h2 class="feedback-modal-title">Chat History</h2>
            <div class="feedback-meta">
              <span>{{ selectedFeedback.chatLabel || 'Untitled Chat' }}</span>
              <span>{{ getFeedbackCountForChat(selectedFeedback.chatId) }} feedbacks</span>
            </div>
          </div>
        </div>

        <div class="feedback-modal-header-actions">
          <span class="tone-chip" *ngIf="viewMode === 'feedback'" [class.negative]="selectedFeedback.feedback.isLiked === false">
            {{ getFeedbackTone(selectedFeedback) }}
          </span>
          <button type="button" class="modal-close-btn" (click)="closeFeedbackDetails()" aria-label="Close details">
            &#10005;
          </button>
        </div>
      </div>

      <div class="feedback-modal-body" *ngIf="viewMode === 'feedback'" #feedbackModalBody>
        <section class="detail-block">
          <div class="feedback-label">User Prompt</div>
          <div class="detail-surface">{{ formatDisplayText(selectedFeedback.userMessage, 'No prompt available.') }}</div>
        </section>

        <section class="detail-block">
          <div class="feedback-label">AI Response</div>
          <div class="detail-surface response-surface">
            <div
              class="modal-markdown-content"
              *ngIf="selectedFeedback.aiResponse; else aiFallback"
              [innerHTML]="selectedFeedback.aiResponse | markdown">
            </div>
            <ng-template #aiFallback>No AI response available.</ng-template>
          </div>
        </section>

        <section class="detail-block">
          <div class="feedback-label">Feedback</div>
          <div class="detail-surface">{{ formatDisplayText(selectedFeedback.feedback.comment, 'No written comment provided.') }}</div>
        </section>

        <section class="detail-block" *ngIf="selectedFeedback.feedback.isResolved">
          <div class="feedback-label">Resolution</div>
          <div class="detail-surface detail-muted">
            Resolved{{ selectedFeedback.feedback.resolvedByName ? ' by ' + selectedFeedback.feedback.resolvedByName : '' }}
            <span *ngIf="selectedFeedback.feedback.resolvedAt"> on {{ selectedFeedback.feedback.resolvedAt | date:'medium' }}</span>
          </div>
        </section>
      </div>

      <div class="feedback-modal-body history-layout" *ngIf="viewMode === 'history'" #historyModalBody>
        <aside class="history-sidebar">
          <div class="history-summary">
            <div class="history-summary-label">Total Feedbacks</div>
            <div class="history-summary-value">{{ chatHistoryFeedbacks.length }}</div>
          </div>

          <div class="history-feedback-list">
            <button
              type="button"
              class="history-feedback-item"
              *ngFor="let item of chatHistoryFeedbacks"
              [class.active]="selectedHistoryFeedback?.messageIndex === item.messageIndex"
              (click)="selectHistoryFeedback(item)">
              <div class="history-feedback-top">
                <span class="history-feedback-title">Feedback #{{ item.messageIndex + 1 }}</span>
                <span class="tone-chip compact" [class.negative]="item.feedback.isLiked === false">
                  {{ getFeedbackTone(item) }}
                </span>
              </div>

              <div class="history-stars" aria-label="Feedback rating">
                <span
                  class="history-star"
                  *ngFor="let star of getStars()"
                  [class.filled]="isStarFilled(star, getFeedbackRating(item))">
                  ★
                </span>
              </div>
            </button>
          </div>
        </aside>

        <section class="history-content">
          <div class="loading-state" *ngIf="isLoadingChatHistory">
            <div class="loading-spinner"></div>
          </div>

          <div class="error-state" *ngIf="chatHistoryError && !isLoadingChatHistory">
            <div class="error-content">
              <p class="error-message">{{ chatHistoryError }}</p>
            </div>
          </div>

          <div class="history-messages" *ngIf="!isLoadingChatHistory && !chatHistoryError">
            <div class="history-message-pair" *ngFor="let historyMessage of getVisibleChatHistoryMessages(); let i = index">
              <div class="history-message user-message">
                <div class="history-message-label">User</div>
                <div class="detail-surface">{{ formatDisplayText(historyMessage.UserMessage, 'No prompt available.') }}</div>
              </div>

              <div
                class="history-message ai-message"
                [attr.data-history-feedback-index]="i"
                [class.highlighted]="selectedHistoryFeedback?.messageIndex === i">
                <div class="history-message-label">AI</div>
                <div class="detail-surface response-surface">
                  <div
                    class="modal-markdown-content"
                    *ngIf="historyMessage.AIResponse; else historyAiFallback"
                    [innerHTML]="historyMessage.AIResponse | markdown">
                  </div>
                  <ng-template #historyAiFallback>No AI response available.</ng-template>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="feedback-modal-footer" *ngIf="viewMode === 'feedback'">
        <button
          type="button"
          class="history-btn"
          (click)="openChatHistory()">
          Show Chat History
        </button>
        <button
          type="button"
          class="resolve-btn"
          *ngIf="!selectedFeedback.feedback.isResolved"
          (click)="resolveFeedback(selectedFeedback)"
          [disabled]="resolvingKey === getFeedbackKey(selectedFeedback)">
          {{ resolvingKey === getFeedbackKey(selectedFeedback) ? 'Resolving...' : 'Resolve Feedback' }}
        </button>
      </div>
    </div>
  </div>
</div>
